import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import ReactGA from 'react-ga4';
import { useEffect } from 'react';
// Import page components
import Home from './pages/Home';
import ChiSiamo from './pages/ChiSiamo';
import Partners from './pages/Partners';
import ConsiglioDirectivo from './pages/ConsiglioDirectivo';
import Sostienici from './pages/Sostienici';
import MalattieRare from './pages/MalattieRare';
import Eventi from './pages/Eventi';
import Contatti from './pages/Contatti';
import Volontari from './pages/Volontari';
import Soci from './pages/Soci';

// Route tracking component
function RouteTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Send pageview with current page URL
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
  
  return null;
}

function App() {
  return (
    <PayPalScriptProvider options={{
      "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID || "sb", // Use sandbox mode by default
      currency: "EUR",
      intent: "capture",
      vault: true
    }}>
      <BrowserRouter>
        <RouteTracker />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            {/* Home page as index route */}
            <Route index element={<Home />} />
            
            {/* Main navigation routes */}
            <Route path="chi-siamo" element={<ChiSiamo />} />
            <Route path="malattie-rare" element={<MalattieRare />} />
            <Route path="eventi" element={<Eventi />} />
            <Route path="partners" element={<Partners />} />
            <Route path="consiglio-direttivo" element={<ConsiglioDirectivo />} />
            <Route path="sostienici" element={<Sostienici />} />
            <Route path="contatti" element={<Contatti />} />
            <Route path="volontari" element={<Volontari />} />
            <Route path="soci" element={<Soci />} />
            
            {/* Handle redirects for legacy URLs if needed */}
            <Route path="about" element={<Navigate replace to="/chi-siamo" />} />
            <Route path="donate" element={<Navigate replace to="/sostienici" />} />
            
            {/* 404 - Not Found page */}
            <Route path="*" element={
              <div className="min-h-[60vh] flex flex-col items-center justify-center bg-gray-100 py-16">
                <h2 className="text-4xl font-bold text-center text-green-800 mb-8">Pagina non trovata</h2>
                <p className="text-lg text-center text-gray-700 max-w-3xl mx-auto mb-8">
                  La pagina che stai cercando non esiste. Torna alla homepage per continuare la navigazione.
                </p>
                <a href="/" className="px-6 py-3 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 transition-colors">
                  Torna alla Home
                </a>
              </div>
            } />
          </Route>
        </Routes>
      </BrowserRouter>
    </PayPalScriptProvider>
  );
}

export default App;
